import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ServicePage from "@/pages/ServicePage";
import CountyPage from "@/pages/CountyPage";
import CityPage from "@/pages/CityPage";
import PropertyManagersPage from "@/pages/PropertyManagersPage";
import RequestServicePage from "@/pages/RequestServicePage";
import { AboutPage, BrandsPage, FaqPage, ReviewsPage, NotFoundPage } from "@/pages/InfoPages";
import { SERVICES } from "@/data/services";
import { COUNTIES, CITIES } from "@/data/locations";
import { initAnalytics } from "@/lib/analytics";

const REDIRECTS = {
    "/weekly": "/",
    "/refrigerator-not-cooling": "/refrigerator-repair",
    "/dryer-not-heating": "/dryer-repair",
    "/washer-not-draining": "/washer-repair",
    "/dishwasher-not-draining": "/dishwasher-repair",
    "/oven-not-heating": "/oven-repair",
};

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, duration: 1.05 });
        window.__lenis = lenis;
        initAnalytics();
        return () => lenis.destroy();
    }, []);

    return (
        <HelmetProvider>
            <div className="App">
                <BrowserRouter>
                    <ScrollToTop />
                    <Routes>
                        {Object.entries(REDIRECTS).map(([from, to]) => (
                            <Route key={from} path={from} element={<Navigate to={to} replace />} />
                        ))}
                        <Route element={<Layout />}>
                            <Route path="/" element={<HomePage />} />
                            {SERVICES.map((s) => (
                                <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
                            ))}
                            {COUNTIES.map((c) => (
                                <Route key={c.slug} path={`/${c.slug}`} element={<CountyPage county={c} />} />
                            ))}
                            {CITIES.map((c) => (
                                <Route key={c.slug} path={`/${c.slug}`} element={<CityPage city={c} />} />
                            ))}
                            <Route path="/property-managers" element={<PropertyManagersPage />} />
                            <Route path="/request-service" element={<RequestServicePage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/brands-we-service" element={<BrandsPage />} />
                            <Route path="/faq" element={<FaqPage />} />
                            <Route path="/reviews" element={<ReviewsPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Route>
                    </Routes>
                    <Toaster position="top-center" richColors />
                </BrowserRouter>
            </div>
        </HelmetProvider>
    );
}

export default App;
